import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import clearModal from '@shoflo/studio-redux/actions/modal/clearModal/clearModal';
import ModalHeader from 'components/Modal/Header';
import { BACKGROUND_TEMPLATES } from 'constants/ModalTypes';
import TemplateWrapper from 'containers/pages/Broadcast/Templates';
import copyTemplate from 'actions/Broadcast/templates/copyTemplate';

const BackgroundTemplates = () => {
  const dispatch = useDispatch();

  const isOpen = useSelector(
    ({ modal }) => modal && modal.type === BACKGROUND_TEMPLATES
  );

  const clearThisModal = () => dispatch(clearModal(BACKGROUND_TEMPLATES));
  const onSelectTemplate = template => {
    const payload = {
      type: template.type || 'backgrounds',
      title: template.name || template.key,
      isEventTemplate: template.isEventTemplate
    };
    if (template._id) {
      payload._id = template._id;
    }
    dispatch(copyTemplate(payload));
    clearThisModal();
  };

  if (!isOpen) return null;

  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      toggle={clearThisModal}
      data-testid="backgrounds-template-chooser-modal"
    >
      <ModalHeader>Add a background</ModalHeader>
      <ModalBody>
        <TemplateWrapper
          title={'backgrounds'}
          onCancel={clearThisModal}
          onSelectTemplate={onSelectTemplate}
        />
      </ModalBody>
    </Modal>
  );
};

export default BackgroundTemplates;
